<template lang="pug">
  div.e-data-grid-inner
    div(v-if="loading").wrapper
      p Загрузка данных
    div(v-else-if="error").wrapper
      p {{error}}
    div(v-else-if="data && data.data && data.data.length > 0").wrapper
      div.items
        div(
        v-for="(dataValue, dataIndex) in data.data"
        :key="dataValue.id"
        :data-id="dataValue.id"
        ).item
          slot(
          v-if="$scopedSlots.header"
          :dataIndex="dataIndex"
          :row="dataValue"
          name="header"
          )
          div(
           v-else
          ).row.title {{transformTitle(dataValue)}}
          template(
          v-for="item, fieldName, itemIndex in fieldsRows"
          v-if="visibleRows.indexOf(fieldName) > -1"
          )
            template(
            v-if="$scopedSlots[fieldName]"
            )
              slot(
              :name="fieldName"
              :row="dataValue"
              )
            template(
            v-else
            )
              div(
              :class="`title-of-field-${fieldName}`"
              :style="`grid-area:title-of-field-${fieldName};`"
              ).item-row-title
                div {{gridMeta.fields[fieldName].label}}
              div(
              :class="`value-of-field-${fieldName}`"
              :style="`grid-area:value-of-field-${fieldName};`"
              ).item-row-value
                div(
                v-if="typeof dataValue[fieldName] === 'boolean'"
                ) {{dataValue[fieldName] ? 'Да' : 'Нет'}}
                div(
                v-else-if="typeof(dataValue[fieldName]) !== 'object'"
                v-html="dataValue[fieldName]"
                )
                div(
                v-else-if="Array.isArray(dataValue[fieldName]) && dataValue[fieldName].length > 0"
                )
                  span(
                  v-for="item in dataValue[fieldName]"
                  ) {{ item.name + ' ' }}
                div(
                v-else-if="dataValue[fieldName] && gridMeta.fields[fieldName].path"
                ) {{ dataValue[fieldName][gridMeta.fields[fieldName].path] }}
                div(
                v-else-if="dataValue[fieldName] && dataValue[fieldName].name"
                ) {{ dataValue[fieldName].name }}

    div(v-else).wrapper
      p Записи не найдены
</template>

<script>
  import userFriendlyEr from '../../utils/userFriendlyEr.js'

  export default {
    name: 'e-data-grid-inner',
    data () {
      return {
        loading: false,
        error: null,
        data: {},
        meta: {}
      }
    },
    props: {
      dataUrl: {
        type: String,
        default: null
      },
      showedFields: {
        type: Array,
        default: function () {
          return []
        }
      },
      offline: {
        type: Boolean,
        default: false
      },
      transformTitle: {
        type: Function,
        default: function (model) {
          return model.title || model.name || ' - '
        }
      }
    },
    watch: {
      dataUrl: 'fetchData',
      loading: 'onLoading'
    },
    created () {
      this.fetchData()
    },
    computed: {
      fieldsRows () {
        if (this.gridMeta && this.gridMeta.fields) {
          return this.gridMeta.fields
        }
        return {}
      },
      gridOffline () {
        return this.offline
      },
      gridMeta () {
        return this.meta
      },
      visibleRows () {
        if (this.showedFields.length > 0) {
          return this.showedFields
        }
        if (this.gridMeta && this.gridMeta.fields) {
          return Object.keys(this.gridMeta.fields)
        }
        return []
      }
    },
    methods: {
      onLoading () {
        if (this.loading) {
          this.$bar.start()
        } else {
          this.$bar.finish()
        }
      },
      fetchData () {
        if (this.dataUrl) {
          this.loading = true
          this.error = null
          const endpoint = this.dataUrl
          this.$sharedServices.store.dispatch('updateUrlEndpoint', {
            endpoint,
            offline: this.gridOffline,
            params: {
              disableGlobalError: true
            }
          }).then(r => {
            this.data = null
            this.data = Object.assign({}, r.data)
            this.meta = Object.assign({}, r.data._meta || {})
            this.loading = false
          }).catch(e => {
            this.loading = false
            this.error = userFriendlyEr.recognize(e, endpoint)
          })
        }
      }
    }
  }
</script>
